module.exports = __webpack_public_path__ + "static/media/cloud-rain.34b9aca4.svg";